import { HttpAxiosRequest } from '../../../../../http/httpAxiosBase'
import {
    CLFBDetalle,
    CLFBDetalle_InsertDTO, CLFBDetalleHistoria, CLFBLimiteAprobado, CLFBLimitesAprobadosPais,
    OperacionCLFB,
    schemaCLFBDetalle,
    schemaCLFBDetalleHistoria, schemaCLFBLimiteAprobado, schemaCLFBLimitesAprobados,
    schemaOperacionCLFB
} from '../types/types'
import { z } from 'zod'
import { BaseResponse } from '../../../../../types'
import {
    OperacionCLFBInsert,
    OperacionCLFBUpdate,
    schemaOperacionCLFBInsert,
    schemaOperacionCLFBUpdate
} from '../types/dto'
import {HttpOperacionInforme} from "../../../api/httpOperacionInforme";
import {SistemaTipo} from "../../../../../types/enum/enum";
import {FormFiltros} from "../../../../limites/FiltrosBusqueda";


export const getEndpoint = (url = ''): string => `operaciones/clfb/${url}`
export const getEndpointCache = (url = ''): string => `cache/operaciones/clfb/${url}`

export const HttpCLFB = {
    get: (idOperacion: number): Promise<OperacionCLFB> => {
        return HttpAxiosRequest.get(getEndpoint(`${idOperacion}`))
            .then(response => {
                const parsed = schemaOperacionCLFB.safeParse(response)

                if (!parsed.success) {
                    console.error('Error de validación:', parsed.error.issues)

                    return Promise.reject(new Error('Error de validación.'))
                }

                return parsed.data
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },
    put: (idOperacion: number, operacion: OperacionCLFBUpdate): Promise<BaseResponse> => {
        const parsed = schemaOperacionCLFBUpdate.safeParse(operacion)

        if (!parsed.success) {
            console.error('Error de validación:', parsed.error.issues)

            return Promise.reject(new Error('Error de validación.'))
        }

        return HttpAxiosRequest.put(getEndpoint(`${idOperacion}`), parsed.data)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },
    post: (operacion: OperacionCLFBInsert): Promise<BaseResponse> => {
        const parsed = schemaOperacionCLFBInsert.safeParse(operacion)

        if (!parsed.success) {
            console.error('Error de validación:', parsed.error.issues)

            return Promise.reject(new Error('Error de validación.'))
        }

        return HttpAxiosRequest.post(getEndpoint(), parsed.data)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },
    getDetalle: (idOperacion?: number): Promise<CLFBDetalle[]> => {
        return HttpAxiosRequest.get(getEndpoint(`${idOperacion}/detalles`))
            .then(response => {
                const parsed = z.array(schemaCLFBDetalle).safeParse(response)

                if (!parsed.success) {
                    console.error('Error de validación:', parsed.error.issues)

                    return Promise.reject(new Error('Error de validación.'))
                }

                return parsed.data
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    getDetalleHistoria: (idOperacion?: number): Promise<CLFBDetalleHistoria[]> => {
        return HttpAxiosRequest.get(getEndpoint(`${idOperacion}/detalles/historico`))
          .then(response => {
              const parsed = z.array(schemaCLFBDetalleHistoria).safeParse(response)

              if (!parsed.success) {
                  console.error('Error de validación:', parsed.error.issues)

                  return Promise.reject(new Error('Error de validación.'))
              }

              return parsed.data
          })
          .catch(error => {
              console.error('Error de red:', error)

              return Promise.reject('Error de red.')
          })
    },

    putDetalle: (idOperacion:number, idDetalle: number, detalle: CLFBDetalle_InsertDTO): Promise<BaseResponse> => {
        return HttpAxiosRequest.put(getEndpoint(`${idOperacion}/detalles/${idDetalle}`), detalle)
    },

    descargarInforme: (idOperacion: number): Promise<any> =>
        HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.CLFB),

    updateAgregadoNeto: (idOperacion: number, agregadoNeto: number): Promise<BaseResponse> => {
        return HttpAxiosRequest.put(getEndpoint(`${idOperacion}/agregado-neto/${agregadoNeto}`), {  })
    },

    updateAgregadAbsoluto: (idOperacion: number, agregadoAbsoluto: number): Promise<BaseResponse> => {
        return HttpAxiosRequest.put(getEndpoint(`${idOperacion}/agregado-absoluto/${agregadoAbsoluto}`), {  })
    },

    getLimitesAprobados: (filtros: FormFiltros): Promise<CLFBLimitesAprobadosPais[]> => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(getEndpoint(`limites`), {...filtros})
            .then(response => {
                const parsed = z.array(schemaCLFBLimitesAprobados).safeParse(response)

                if (!parsed.success) {
                    console.error('Error de validación:', parsed.error.issues)

                    return Promise.reject(new Error('Error de validación.'))
                }

                return parsed.data
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

} as const
